const fullApiUrl = process.env.REACT_APP_API_URL;
const apiVersion = process.env.REACT_APP_API_VERSION;
const connectfullApiUrl = process.env.REACT_APP_CONNECT_API_URL;
const connectApiVersion = process.env.REACT_APP_CONNECT_API_VERSION;
const username = process.env.REACT_APP_USERNAME;
const password = process.env.REACT_APP_PASSWORD;

export default {
    fullApiUrl,
    apiVersion,
    connectfullApiUrl,
    connectApiVersion,
    username,
    password,
};